import { useLocalStore } from "@store/useLocalStore";
import useSWR from "swr";

export const useFetch = (url = null, dataToSend = {}, options = {}) => {

    const token = useLocalStore((state) => state.user.token);
    const { setUserToken, setUserRole } = useLocalStore((state) => state);

    const fetcher = async (newUrl = url, newDataToSend = dataToSend, newOptions = options) => {
        if (!newUrl) return;

        const isFormData = newDataToSend instanceof FormData;
        const baseConfig = {
            headers: {
                'Authorization': `Bearer ${token}`,
                ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            },
            // Always include 'body' when method is specified and newDataToSend is present
            ...(newOptions.method && newDataToSend != null ? { body: isFormData ? newDataToSend : JSON.stringify(newDataToSend) } : {}),
            method: newOptions.method,
        };

        const mergedConfig = {
            ...baseConfig,
            ...newOptions,
            headers: { ...baseConfig.headers, ...newOptions.headers },
        };

        try {
            const response = await fetch(newUrl, mergedConfig);
            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    setUserToken(null);
                    setUserRole(null);
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('An error occurred:', error.message);
            throw error;
        }
    };

    const { data, error, isValidating, mutate } = useSWR(url, fetcher, {
        revalidateOnFocus: false,
        shouldRetryOnError: false
    });
    const isLoading = isValidating;

    const triggerFetch = async (newUrl, newDataToSend = {}, newOptions = {}) => {

        try {
            const result = await fetcher(newUrl, newDataToSend, newOptions);
            return result;
        } catch (error) {
            console.error('An error occurred:', error.message);
            throw error;
        }
    };

    return [data, error, isLoading, triggerFetch, mutate];
};